import { isIE } from './isIE';
import { isLegacyEdge } from './isLegacyEdge';

export const isLegacyBrowser = () => {
    return isIE() || isLegacyEdge();
};
